<div class="invoices-table-options">
  <div class="d-flex">
    <div *ngIf="{ value: invoicesFilter$ | async } as selectedFilter" class="table-filter-tab-container">
      <button
        type="button"
        class="table-filter-tab px-4"
        [ngClass]="{ selected: selectedFilter.value === InvoicesTableFilterOptions.ALL }"
        (click)="setInvoicesFilter(InvoicesTableFilterOptions.ALL)"
      >
        All
        <pill
          class="ms-2"
          [color]="selectedFilter.value === InvoicesTableFilterOptions.ALL ? 'primary' : 'gray'"
          [dark]="true"
          [value]="(invoiceTotals$ | async)?.all"
          size="small"
        />
      </button>
      <button
        type="button"
        class="table-filter-tab px-4"
        [ngClass]="{ selected: selectedFilter.value === InvoicesTableFilterOptions.UNPAID }"
        (click)="setInvoicesFilter(InvoicesTableFilterOptions.UNPAID)"
      >
        Unpaid
        <pill
          class="ms-2"
          [color]="selectedFilter.value === InvoicesTableFilterOptions.UNPAID ? 'primary' : 'gray'"
          [dark]="true"
          [value]="(invoiceTotals$ | async)?.unpaid"
          size="small"
        />
      </button>
      <button
        type="button"
        class="table-filter-tab px-4"
        [ngClass]="{ selected: selectedFilter.value === InvoicesTableFilterOptions.PAID }"
        (click)="setInvoicesFilter(InvoicesTableFilterOptions.PAID)"
      >
        Paid
        <pill
          class="ms-2"
          [color]="selectedFilter.value === InvoicesTableFilterOptions.PAID ? 'primary' : 'gray'"
          [dark]="true"
          [value]="(invoiceTotals$ | async)?.paid"
          size="small"
        />
      </button>
    </div>
  </div>

  <div class="d-flex">
    <app-ag-grid-clear-column-filters-button *ngIf="columnFilterApplied$ | async" class="text-nowrap me-2" [gridApi]="gridApi$ | async" />
    <input type="text" class="form-input form-input--search me-4" [formControl]="searchBarControl" placeholder="Search" />
    <app-ag-grid-export-all-button
      [columnApi]="columnApi$ | async"
      [columnDefs]="columnDefs"
      [datasourceMarshallFn]="datasourceMarshallFn"
      [defaultColumnDef]="defaultColumnDef"
      [externalFilters]="datasource.externalFilters"
      [gridApi]="gridApi$ | async"
      [gridOptions]="gridOptions"
      [query]="query"
      [tableId]="id"
    />
  </div>
</div>
<div class="invoices-table">
  <ag-grid-angular
    class="ag-theme-material h-100"
    [columnDefs]="columnDefs"
    [defaultColDef]="defaultColumnDef"
    [gridOptions]="gridOptions"
    (gridReady)="onGridReady($event)"
  />
  <ng-template #actionsTemplate let-row>
    <button class="button button--sm button--text" [matMenuTriggerFor]="menu">
      <anduin-icon name="more-horizontal" stroke="#80879B" />
    </button>
    <mat-menu #menu="matMenu">
      <div [tooltipEnabled]="!row.data.invoiceFileId" tooltip="The PDF for this invoice is not available in Aiwyn.">
        <button [disabled]="!row.data.invoiceFileId" (click)="viewInvoicePdf(row.data.id)" mat-menu-item>View Invoice</button>
      </div>

      @let disableResendInvoice = !row.data.invoiceFileId || !canResendInvoices();
      <div
        [tooltip]="
          !row.data.invoiceFileId
            ? 'The PDF for this invoice is not available to be resent in Aiwyn.'
            : 'You do not have permission to resend invoices.'
        "
        [tooltipEnabled]="disableResendInvoice"
      >
        <button [disabled]="disableResendInvoice" (click)="!disableResendInvoice && resendInvoice(row.data)" mat-menu-item>
          Resend Invoice
        </button>
      </div>

      @let disableViewDraftBill = !row.data.draftBill || !canViewBilling();
      <div
        [tooltip]="
          !row.data.draftBill ? 'There is no draft invoice for this invoice.' : 'You do not have permission to view draft invoices.'
        "
        [tooltipEnabled]="disableViewDraftBill"
      >
        <button
          [disabled]="disableViewDraftBill"
          (click)="!disableViewDraftBill && viewDraftBill(row.data.draftBill.arTranId)"
          mat-menu-item
        >
          View Aiwyn Draft Invoice
        </button>
      </div>

      <div [tooltipEnabled]="!row.data.invoiceFileId" tooltip="The PDF for this invoice is not available in Aiwyn.">
        <button [disabled]="!row.data.invoiceFileId" (click)="row.data.invoiceFileId && downloadInvoice(row.data.id)" mat-menu-item>
          Download Invoice
        </button>
      </div>

      @let isFullyPaid = (row.data.outstandingInCurrency ?? row.data.outstanding) === 0;
      <div [tooltipEnabled]="isFullyPaid" tooltip="This invoice is fully paid">
        <button [disabled]="isFullyPaid" (click)="!isFullyPaid && createPayment(row.data)" mat-menu-item>Create Payment</button>
      </div>

      @let canLaunchClientPortal = canLaunchClientPortal$ | async;
      <div [tooltipEnabled]="!canLaunchClientPortal" tooltip="You do not have permission to access the client portal.">
        <button [disabled]="!canLaunchClientPortal" (click)="canLaunchClientPortal && navigateToClientPortal(row.data)" mat-menu-item>
          Client Portal View
        </button>
      </div>

      @let reverseState = reverseInvoiceState(row.data);
      @let canReverseInvoice = reverseState === 'ok';
      <div [tooltipEnabled]="!canReverseInvoice" [tooltip]="reverseInvoiceTooltip(row.data)">
        <button [disabled]="!canReverseInvoice" (click)="openReverseInvoiceConfirmationDialog(row.data.id, row.data)" mat-menu-item>
          Reverse Invoice
        </button>
      </div>
    </mat-menu>
  </ng-template>
</div>

<app-batch-actions-toolbar
  [actions]="toolbarActions"
  [maxActions]="1"
  [selectedText]="selectedText()"
  [value]="selectedInvoices()"
  [visible]="toolbarVisible()"
  (closeToolbar)="deselectAllInvoices()"
/>

<ng-template #createPaymentDrawer>
  <app-create-payment-drawer
    [clientId]="drawerClientId()"
    [currencyCode]="drawerCurrencyCode()"
    [invoiceId]="drawerInvoiceId()"
    [invoiceNumber]="drawerInvoiceNumber()"
    [outstandingAmount]="drawerOutstandingAmount()"
    (paymentCreated)="onPaymentCreated()"
  />
</ng-template>
